/* ============================================================
   YCODE — shared section behaviour
   Loaded once via {{ 'ycode-sections.js' | asset_url | script_tag }}
   (defer) before </body> in theme.liquid.
   All handlers are idempotent & re-run on Shopify editor events.
   ============================================================ */
(function () {
  'use strict';

  /* ---- Lazy-load / autoplay looping muted videos on scroll ---- */
  function initLazyVideos(root) {
    var vids = (root || document).querySelectorAll('video[data-yc-lazyvid]');
    if (!vids.length) return;
    function nearView(v) { var r = v.getBoundingClientRect(); return r.width > 0 && r.height > 0 && r.top < (window.innerHeight + 300) && r.bottom > -300; }
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { play(v); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) play(e.target);
        else e.target.pause();
      });
    }, { threshold: 0.01, rootMargin: '300px 0px' });
    vids.forEach(function (v) { io.observe(v); });
    /* Fallback: the observer can fail to fire for very tall full-bleed sections in some
       browsers, leaving the video black. Load anything near the viewport now, and again on
       scroll/resize. play() is idempotent so already-loaded videos are skipped. */
    function sweep() { vids.forEach(function (v) { if (nearView(v)) play(v); }); }
    sweep();
    window.addEventListener('scroll', sweep, { passive: true });
    window.addEventListener('resize', sweep, { passive: true });
    /* Safety net: the observer reliably fails to fire for some tall full-bleed video-bands.
       Poll briefly after load so any in-view video loads even if IO and scroll both miss it. */
    var _pt = 0, _poll = setInterval(function () { sweep(); if (++_pt > 20) clearInterval(_poll); }, 400);

    function play(v) {
      if (v.dataset.ycLoaded !== '1') {
        v.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.dataset.src; });
        if (v.dataset.src) v.src = v.dataset.src;
        v.load();
        v.dataset.ycLoaded = '1';
      }
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
  }

  /* ---- Scrollable mobile gallery: dot indicator sync ---- */
  function initGalleries(root) {
    (root || document).querySelectorAll('[data-yc-gallery]').forEach(function (g) {
      var track = g.querySelector('[data-yc-gallery-track]');
      var dots = g.querySelectorAll('[data-yc-dot]');
      if (!track || !dots.length) return;
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, di) { d.setAttribute('data-active', di === i ? 'true' : 'false'); });
      }, { passive: true });
    });
  }

  /* ---- Money formatting (multi-currency / Shopify Markets) ----
     We never hardcode a currency symbol. A hidden sample rendered by
     Liquid ({{ 123456 | money }}) tells us the ACTIVE market's symbol,
     placement and separators, so JS-computed totals match the store. */
  function ycMoneyFormat() {
    var el = document.querySelector('[data-yc-money-sample]');
    var fallback = { tmpl: '\u00A3{{a}}', decimal: '.', thousand: ',' };
    if (!el) return fallback;
    var s = (el.textContent || '').trim();
    if (!s) return fallback;
    var lastDot = s.lastIndexOf('.'), lastComma = s.lastIndexOf(',');
    var decimal = lastComma > lastDot ? ',' : '.';
    var thousand = decimal === ',' ? '.' : ',';
    var tmpl = s.replace(/[\d.,\s\u00A0]*\d/, '{{a}}');
    return { tmpl: tmpl, decimal: decimal, thousand: thousand };
  }
  function ycFmt(cents, fmt) {
    cents = Math.round(Number(cents) || 0);
    var neg = cents < 0; cents = Math.abs(cents);
    var parts = (cents / 100).toFixed(2).split('.');
    var intp = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, fmt.thousand);
    var num = intp + fmt.decimal + parts[1];
    return (neg ? '-' : '') + fmt.tmpl.replace('{{a}}', num);
  }

  /* ---- Build-your-routine kit picker ----
     Reads product + kit data from a JSON <script> in the section.
     Prices are in CENTS of the active presentment currency. */
  function initKitPickers(root) {
    (root || document).querySelectorAll('[data-yc-kit]').forEach(function (wrap) {
      var dataEl = wrap.querySelector('[data-yc-kit-data]');
      if (!dataEl) return;
      var cfg;
      try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
      /* Price test. A no-op unless a test is running and this visitor is in
         the lower-priced group. Defined inline in the head by
         snippets/yc-price-test.liquid. */
      try { if (window.YC_PT && window.YC_PT.patch) cfg = window.YC_PT.patch(cfg, 'kit'); } catch (e) {}

      var rows = wrap.querySelectorAll('[data-yc-pick]');
      var out = {
        name:   wrap.querySelector('[data-yc-kb-name]'),
        items:  wrap.querySelector('[data-yc-kb-items]'),
        price:  wrap.querySelector('[data-yc-kb-price]'),
        strike: wrap.querySelector('[data-yc-kb-strike]'),
        save:   wrap.querySelector('[data-yc-kb-save]'),
        hint:   wrap.querySelector('[data-yc-kb-hint]'),
        add:    wrap.querySelector('[data-yc-kb-add]')
      };
      var sel = {};
      rows.forEach(function (r) { sel[r.getAttribute('data-yc-pick')] = r.getAttribute('data-yc-selected') === 'true'; });

      function render() {
        var chosen = Object.keys(sel).filter(function (k) { return sel[k]; });
        var full = chosen.reduce(function (t, k) { return t + (cfg.products[k] ? cfg.products[k].price : 0); }, 0);
        var key = chosen.slice().sort().join('+');
        var kit = cfg.kits[key];
        var fmt = ycMoneyFormat();

        rows.forEach(function (r) {
          var k = r.getAttribute('data-yc-pick');
          r.setAttribute('data-yc-selected', sel[k] ? 'true' : 'false');
        });

        /* Wire the CTA to the cart-drawer quick-add (data-yc-quickadd + data-items) so it
           adds to cart instead of navigating to the PDP. Falls back to a product link
           only if a variant id is unavailable. */
        function wireAdd(el, items, fallbackUrl){
          if (!el) return;
          if (items && items.length && items.indexOf(null) === -1) {
            el.setAttribute('data-yc-quickadd', '');
            el.setAttribute('data-items', JSON.stringify(items));
            el.setAttribute('href', '#');
          } else {
            el.removeAttribute('data-yc-quickadd');
            el.removeAttribute('data-items');
            if (fallbackUrl) { el.setAttribute('href', fallbackUrl); } else { el.removeAttribute('href'); }
          }
        }

        if (!chosen.length) {
          set(out.name, 'Choose your products');
          set(out.items, 'Tick one or more products to begin.');
          set(out.price, ''); set(out.strike, ''); set(out.save, '');
          set(out.hint, 'Select at least one product.');
          if (out.add) { out.add.textContent = 'SELECT A PRODUCT'; wireAdd(out.add, null, null); }
          return;
        }

        var label = chosen.map(function (k) { return cfg.products[k].name; }).join('  ·  ');
        set(out.items, label);

        if (kit) {
          set(out.name, kit.name);
          set(out.price, ycFmt(kit.price, fmt));
          set(out.strike, ycFmt(full, fmt));
          set(out.save, 'SAVE ' + ycFmt(full - kit.price, fmt));
          set(out.hint, '✓ Best-value kit applied, free shipping included.');
          if (out.add) { out.add.textContent = 'ADD ' + kit.name.toUpperCase() + ' · ' + ycFmt(kit.price, fmt); wireAdd(out.add, kit.variant_id ? [{ id: kit.variant_id, quantity: 1 }] : null, kit.url); }
        } else {
          var single = chosen.length === 1 ? cfg.products[chosen[0]] : null;
          set(out.name, single ? single.name : chosen.length + ' products');
          set(out.price, ycFmt(full, fmt));
          set(out.strike, '');
          set(out.save, '');
          set(out.hint, chosen.length > 1 ? 'Add another product to unlock a kit saving.' : 'Single product, no kit discount.');
          if (out.add) {
            out.add.textContent = 'ADD TO BAG · ' + ycFmt(full, fmt);
            var addItems = chosen.map(function (k) { return cfg.products[k].variant_id ? { id: cfg.products[k].variant_id, quantity: 1 } : null; });
            wireAdd(out.add, addItems, single ? single.url : null);
          }
        }
      }
      function set(el, v) { if (el) el.textContent = v; }

      rows.forEach(function (r) {
        r.addEventListener('click', function () {
          var k = r.getAttribute('data-yc-pick');
          sel[k] = !sel[k];
          render();
        });
      });
      render();
    });
  }

  /* ---- Nav drawer (yc-header) ---- */
  function initNavDrawer() {
    if (window.__ycNavBound) return;
    window.__ycNavBound = true;
    function setOpen(on) {
      var p = document.querySelector('[data-yc-nav-panel]');
      var o = document.querySelector('[data-yc-nav-overlay]');
      if (p) p.classList.toggle('is-open', on);
      if (o) o.classList.toggle('is-open', on);
      document.documentElement.style.overflow = on ? 'hidden' : '';
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-yc-nav-toggle]')) { e.preventDefault(); setOpen(true); }
      else if (e.target.closest('[data-yc-nav-close]') || e.target.closest('[data-yc-nav-overlay]')) { setOpen(false); }
    });
  }

  /* ---- Announcement bar mobile rotator ---- */
  function initAnnbar(root) {
    (root || document).querySelectorAll('[data-yc-annbar]').forEach(function (bar) {
      if (bar.__ycRot) return;
      var holder = bar.parentNode.querySelector('[data-yc-annbar-messages]');
      var msgs; try { msgs = JSON.parse(holder ? holder.textContent : '[]'); } catch (_) { msgs = []; }
      var rot = bar.querySelector('.yc-annbar__rot');
      if (!rot || msgs.length < 2) return;
      var i = 0;
      bar.__ycRot = setInterval(function () {
        if (window.innerWidth > 640) return;
        i = (i + 1) % msgs.length;
        rot.style.opacity = '0';
        setTimeout(function () { rot.textContent = msgs[i]; rot.style.opacity = '1'; }, 300);
      }, 3000);
    });
  }

  /* ---- Mobile footer accordions (yc-footer) ---- */
  function initFooterAccordions(root) {
    /* Attach at any load width; expand/collapse only takes effect on mobile
       (the CSS media query controls visibility). This keeps taps working even
       when the page first loads wide and is later viewed at a mobile size. */
    (root || document).querySelectorAll('.yc-footer__col-title').forEach(function (t) {
      if (t.__ycAcc) return; t.__ycAcc = true;
      t.addEventListener('click', function () {
        if (!window.matchMedia('(max-width:749px)').matches) return;
        var col = t.closest('.yc-footer__col');
        if (col) col.classList.toggle('is-open');
      });
    });
  }

  /* ---- YC Gallery arrows (yc-gallery) ---- */
  function initYcGallery(root) {
    (root || document).querySelectorAll('[data-yc-gal-track]').forEach(function (track) {
      if (track.__ycGal) return; track.__ycGal = true;
      var wrap = track.closest('.yc-gal__wrap') || track.parentNode;
      var prev = wrap.querySelector('[data-yc-gal-prev]');
      var next = wrap.querySelector('[data-yc-gal-next]');
      function step(dir) {
        var panel = track.querySelector('.yc-gal__panel');
        var w = panel ? panel.getBoundingClientRect().width + 2 : 320;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });
  }

  /* ---- Video band: sound on/off toggle (for clips with important audio) ---- */
  function initVideoBandSound(root) {
    (root || document).querySelectorAll('[data-yc-vb-sound]').forEach(function (btn) {
      if (btn.dataset.ycBound === '1') return;
      btn.dataset.ycBound = '1';
      btn.addEventListener('click', function () {
        var band = btn.closest('.yc-videoband');
        if (!band) return;
        var on = btn.getAttribute('aria-pressed') !== 'true';
        band.querySelectorAll('video').forEach(function (v) {
          v.muted = !on;
          if (on) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        });
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.classList.toggle('is-on', on);
        var label = btn.querySelector('[data-yc-vb-sound-label]');
        if (label) label.textContent = on ? 'SOUND ON' : 'SOUND OFF';
      });
    });
  }

  function initAll(root) {
    initLazyVideos(root);
    initGalleries(root);
    initKitPickers(root);
    initNavDrawer();
    initAnnbar(root);
    initFooterAccordions(root);
    initYcGallery(root);
    initVideoBandSound(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Shopify Theme Editor: re-init sections as they load / reload */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
})();

/* ============================================================
   YCODE — PDP: "ADD TO BAG — FORMULA X" dynamic CTA label
   Eye-serum template only. Reads the selected Formula option
   and mirrors it into the add-to-cart button, per the design.
   ============================================================ */
(function () {
  if (!document.body.classList.contains('template-product-eye-serum')) return;

  function selectedFormula() {
    var el =
      document.querySelector('.wt-product__options input[type="radio"]:checked') ||
      document.querySelector('.wt-product__options .f-thumb__list__item.is-selected input') ||
      document.querySelector('.wt-product__options [aria-checked="true"]');
    var v = el && (el.value || el.textContent);
    return v ? String(v).trim() : null;
  }

  function updateCta() {
    var v = selectedFormula();
    document.querySelectorAll('.js-add-to-cart span, .product-form__submit span').forEach(function (span) {
      if (!span.dataset.ycBase) span.dataset.ycBase = span.textContent.trim();
      if (/sold out/i.test(span.dataset.ycBase)) return;
      span.textContent = v
        ? 'ADD TO BAG · ' + v.toUpperCase().replace(/^FORMULA\s*/,'FORMULA ')
        : span.dataset.ycBase;
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.wt-product__options')) setTimeout(updateCta, 50);
  });
  document.addEventListener('DOMContentLoaded', updateCta);
  setTimeout(updateCta, 800); /* after theme variant JS initialises */
})();

/* ---------------------------------------------------------------------------
   Lazy video

   The homepage carried five autoplaying videos below the fold. Autoplay makes a
   browser fetch the file immediately regardless of where the element sits, and
   preload="metadata" does not prevent it, so tens of megabytes began downloading
   on page load and competed with the hero for bandwidth. That is an LCP problem,
   not only a bandwidth one.

   Two separate jobs, and they are not the same job:

   1. FETCH, once the element is within 600px, so the film is ready by the time it
      is scrolled to.
   2. PLAY, only once it is actually visible. Calling play() at fetch time looks
      right and is not: Chrome suspends playback for elements that are off-screen,
      so the video would arrive loaded but frozen on its first frame and nothing
      would ever start it. Playing on visibility also lets us pause on the way out,
      which keeps four vertical films off the CPU while they are not being watched.

   A scroll and resize sweep backs up the observers by geometry. A blank panel
   where a film should be is a far worse failure than one redundant check.
--------------------------------------------------------------------------- */
(function () {
  function ycLazyVideoInit() {
    var vids = [].slice.call(document.querySelectorAll('video[data-yc-lazy-video]'));
    if (!vids.length) return;

    function load(v) {
      if (v.dataset.ycLoaded) return;
      var src = v.getAttribute('data-src');
      if (!src) return;
      v.dataset.ycLoaded = '1';
      v.setAttribute('preload', 'auto');
      v.src = src;
      v.load();
    }

    function play(v) {
      if (!v.dataset.ycLoaded) load(v);
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    function near(v, margin) {
      var r = v.getBoundingClientRect();
      var h = window.innerHeight || document.documentElement.clientHeight;
      return r.top < h + margin && r.bottom > -margin;
    }

    function sweep() {
      vids.forEach(function (v) {
        if (near(v, 600)) load(v);
        if (near(v, 0)) { if (v.paused) play(v); }
        else if (!v.paused) v.pause();
      });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; sweep(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    if ('IntersectionObserver' in window) {
      var fetcher = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          load(e.target);
          fetcher.unobserve(e.target);
        });
      }, { rootMargin: '600px 0px' });

      var player = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) play(e.target);
          else if (!e.target.paused) e.target.pause();
        });
      }, { threshold: 0.01 });

      vids.forEach(function (v) { fetcher.observe(v); player.observe(v); });
    }

    sweep();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ycLazyVideoInit);
  } else {
    ycLazyVideoInit();
  }
  /* Theme editor re-renders a section without reloading the page. */
  document.addEventListener('shopify:section:load', ycLazyVideoInit);
})();
